import { attachmentPermissionSet, hasPermissions } from "helpers";

export const applicationTabs = (
	documentsRequiredPermissions?: boolean,
	permissionNoteSet?: [],
	processorId?: string,
) => [
	{
		to: "get-started",
		label: "Get Started",
	},
	{
		to: "business-info",
		label: "Business Info",
	},
	{
		to: "owner-principal",
		label: "Owner / Principal",
	},
	{
		to: "software-options",
		label: "Software Options",
		isDisabled: !processorId,
		tooltip: processorId
			? null
			: "Please select Processor on the “Get Started” step",
	},
	{
		to: "fees",
		label: "Fees",
	},
	{
		to: "additional-services",
		label: "Additional Services",
	},

	{
		to: "attachments",
		label: "Attachments",
		requiredPermissions:
			documentsRequiredPermissions && attachmentPermissionSet,
	},
	{
		to: "deal-notes",
		label: "Deal Notes",
		requiredPermissions: permissionNoteSet,
	},
	{
		to: "pend-details",
		label: "Pend Details",
	},
	{
		to: "history",
		label: "History",
	},
];

export const getApplicationPaths = (documentsRequiredPermissions?: boolean) =>
	applicationTabs(documentsRequiredPermissions)
		.filter(tab => hasPermissions(tab.requiredPermissions))
		.map(tab => tab.to);
